// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-page { min-height: 100vh; display: flex; flex-direction: column; }

.dashboard-hero {
  background: linear-gradient(135deg, #0f172a, #1e3a8a);
  color: var(--white);
  padding: 48px 0 40px;
}
.dashboard-hero h1 { font-size: 1.8rem; font-weight: 800; margin-bottom: 6px; }
.dashboard-hero p { color: #93c5fd; font-size: .95rem; }

.dashboard-content {
  flex: 1 1;
  padding: 40px 24px 64px;
  display: flex;
  flex-direction: column;
  gap: 40px;
}

.dashboard-section {}

.section-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 24px;
}
.section-title h2 { font-size: 1.2rem; font-weight: 700; }

.dashboard-loading {
  display: flex;
  justify-content: center;
  padding: 48px;
}

/* ── Empty state ── */
.empty-state {
  text-align: center;
  padding: 64px 24px;
  background: var(--surface);
  border-radius: var(--radius);
  border: 2px dashed var(--border);
}
.empty-icon { font-size: 3rem; margin-bottom: 16px; }
.empty-state h3 { font-size: 1.1rem; font-weight: 700; margin-bottom: 8px; }
.empty-state p { color: var(--text-muted); margin-bottom: 24px; font-size: .9rem; }

/* ── Licence cards ── */
.licence-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(360px, 1fr));
  gap: 24px;
}

.licence-card {
  background: var(--white);
  border: 2px solid var(--primary);
  border-radius: var(--radius);
  padding: 28px;
  box-shadow: 0 0 0 4px rgba(37,99,235,.06);
}

.licence-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}
.product-name { font-weight: 700; font-size: .95rem; }

.licence-key-block { margin-bottom: 20px; }
.licence-key-block label { font-size: .8rem; font-weight: 600; color: var(--text-muted); text-transform: uppercase; letter-spacing: .04em; display: block; margin-bottom: 8px; }

.licence-key {
  display: flex;
  align-items: center;
  gap: 8px;
  background: var(--surface);
  border: 1.5px solid var(--border);
  border-radius: var(--radius-sm);
  padding: 10px 14px;
}
.licence-key code {
  font-family: 'Courier New', monospace;
  font-size: .95rem;
  font-weight: 700;
  color: var(--primary);
  letter-spacing: .08em;
  flex: 1 1;
}
.copy-btn { background: none; border: none; font-size: 1rem; cursor: pointer; padding: 2px; }
.copy-btn:hover { opacity: .7; }

.licence-meta {}
.meta-row {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  font-size: .875rem;
  border-bottom: 1px solid var(--border);
}
.meta-row:last-child { border: none; }
.meta-row span { color: var(--text-muted); }

/* ── Pending orders ── */
.order-row {
  background: var(--white);
  border: 1px solid var(--border);
  border-radius: var(--radius-sm);
  padding: 20px 24px;
  margin-bottom: 12px;
}
.order-info { font-size: .95rem; margin-bottom: 6px; }
.order-meta { font-size: .85rem; color: var(--text-muted); margin-bottom: 12px; }
.order-cheque {
  background: #fffbeb;
  border: 1px solid #fde68a;
  border-radius: 6px;
  padding: 12px 16px;
  font-size: .875rem;
  line-height: 1.7;
  color: #78350f;
}
.order-cheque code { background: #fef3c7; padding: 2px 6px; border-radius: 4px; font-size: .85rem; }

/* ── Table ── */
.orders-table-wrap { overflow-x: auto; }
.orders-table {
  width: 100%;
  border-collapse: collapse;
  font-size: .875rem;
}
.orders-table th {
  text-align: left;
  padding: 10px 14px;
  background: var(--surface);
  border-bottom: 2px solid var(--border);
  font-size: .78rem;
  text-transform: uppercase;
  letter-spacing: .05em;
  color: var(--text-muted);
}
.orders-table td {
  padding: 12px 14px;
  border-bottom: 1px solid var(--border);
  color: var(--text);
}
.orders-table tr:last-child td { border-bottom: none; }
.orders-table tr:hover td { background: var(--surface); }

/* ── Download ── */
.download-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  background: var(--white);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 24px 28px;
}
.download-info h3 { font-size: 1rem; font-weight: 700; margin-bottom: 4px; }
.download-info p { font-size: .875rem; color: var(--text-muted); }

@media (max-width: 768px) {
  .licence-grid { grid-template-columns: 1fr; }
  .download-card { flex-direction: column; align-items: flex-start; }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard.css"],"names":[],"mappings":"AAAA,kBAAkB,iBAAiB,EAAE,aAAa,EAAE,sBAAsB,EAAE;;AAE5E;EACE,qDAAqD;EACrD,mBAAmB;EACnB,oBAAoB;AACtB;AACA,qBAAqB,iBAAiB,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;AAC9E,oBAAoB,cAAc,EAAE,iBAAiB,EAAE;;AAEvD;EACE,SAAO;EACP,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,oBAAoB;;AAEpB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;AACA,oBAAoB,iBAAiB,EAAE,gBAAgB,EAAE;;AAEzD;EACE,aAAa;EACb,uBAAuB;EACvB,aAAa;AACf;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;EAC1B,4BAA4B;EAC5B,gCAAgC;AAClC;AACA,cAAc,eAAe,EAAE,mBAAmB,EAAE;AACpD,kBAAkB,iBAAiB,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;AAC3E,iBAAiB,wBAAwB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;;AAElF,wBAAwB;AACxB;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,wBAAwB;EACxB,gCAAgC;EAChC,4BAA4B;EAC5B,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;AACA,gBAAgB,gBAAgB,EAAE,iBAAiB,EAAE;;AAErD,qBAAqB,mBAAmB,EAAE;AAC1C,2BAA2B,gBAAgB,EAAE,gBAAgB,EAAE,wBAAwB,EAAE,yBAAyB,EAAE,qBAAqB,EAAE,cAAc,EAAE,kBAAkB,EAAE;;AAE/K;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,0BAA0B;EAC1B,iCAAiC;EACjC,+BAA+B;EAC/B,kBAAkB;AACpB;AACA;EACE,qCAAqC;EACrC,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;EACrB,SAAO;AACT;AACA,YAAY,gBAAgB,EAAE,YAAY,EAAE,eAAe,EAAE,eAAe,EAAE,YAAY,EAAE;AAC5F,kBAAkB,WAAW,EAAE;;AAE/B,eAAe;AACf;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,kBAAkB;EAClB,sCAAsC;AACxC;AACA,uBAAuB,YAAY,EAAE;AACrC,iBAAiB,wBAAwB,EAAE;;AAE3C,yBAAyB;AACzB;EACE,wBAAwB;EACxB,+BAA+B;EAC/B,+BAA+B;EAC/B,kBAAkB;EAClB,mBAAmB;AACrB;AACA,cAAc,iBAAiB,EAAE,kBAAkB,EAAE;AACrD,cAAc,iBAAiB,EAAE,wBAAwB,EAAE,mBAAmB,EAAE;AAChF;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;AACA,qBAAqB,mBAAmB,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,iBAAiB,EAAE;;AAEnG,gBAAgB;AAChB,qBAAqB,gBAAgB,EAAE;AACvC;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,0BAA0B;EAC1B,sCAAsC;EACtC,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;EACrB,wBAAwB;AAC1B;AACA;EACE,kBAAkB;EAClB,sCAAsC;EACtC,kBAAkB;AACpB;AACA,iCAAiC,mBAAmB,EAAE;AACtD,4BAA4B,0BAA0B,EAAE;;AAExD,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,wBAAwB;EACxB,+BAA+B;EAC/B,4BAA4B;EAC5B,kBAAkB;AACpB;AACA,oBAAoB,eAAe,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;AAC3E,mBAAmB,kBAAkB,EAAE,wBAAwB,EAAE;;AAEjE;EACE,gBAAgB,0BAA0B,EAAE;EAC5C,iBAAiB,sBAAsB,EAAE,uBAAuB,EAAE;AACpE","sourcesContent":[".dashboard-page { min-height: 100vh; display: flex; flex-direction: column; }\n\n.dashboard-hero {\n  background: linear-gradient(135deg, #0f172a, #1e3a8a);\n  color: var(--white);\n  padding: 48px 0 40px;\n}\n.dashboard-hero h1 { font-size: 1.8rem; font-weight: 800; margin-bottom: 6px; }\n.dashboard-hero p { color: #93c5fd; font-size: .95rem; }\n\n.dashboard-content {\n  flex: 1;\n  padding: 40px 24px 64px;\n  display: flex;\n  flex-direction: column;\n  gap: 40px;\n}\n\n.dashboard-section {}\n\n.section-title {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 24px;\n}\n.section-title h2 { font-size: 1.2rem; font-weight: 700; }\n\n.dashboard-loading {\n  display: flex;\n  justify-content: center;\n  padding: 48px;\n}\n\n/* ── Empty state ── */\n.empty-state {\n  text-align: center;\n  padding: 64px 24px;\n  background: var(--surface);\n  border-radius: var(--radius);\n  border: 2px dashed var(--border);\n}\n.empty-icon { font-size: 3rem; margin-bottom: 16px; }\n.empty-state h3 { font-size: 1.1rem; font-weight: 700; margin-bottom: 8px; }\n.empty-state p { color: var(--text-muted); margin-bottom: 24px; font-size: .9rem; }\n\n/* ── Licence cards ── */\n.licence-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(360px, 1fr));\n  gap: 24px;\n}\n\n.licence-card {\n  background: var(--white);\n  border: 2px solid var(--primary);\n  border-radius: var(--radius);\n  padding: 28px;\n  box-shadow: 0 0 0 4px rgba(37,99,235,.06);\n}\n\n.licence-card-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n}\n.product-name { font-weight: 700; font-size: .95rem; }\n\n.licence-key-block { margin-bottom: 20px; }\n.licence-key-block label { font-size: .8rem; font-weight: 600; color: var(--text-muted); text-transform: uppercase; letter-spacing: .04em; display: block; margin-bottom: 8px; }\n\n.licence-key {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: var(--surface);\n  border: 1.5px solid var(--border);\n  border-radius: var(--radius-sm);\n  padding: 10px 14px;\n}\n.licence-key code {\n  font-family: 'Courier New', monospace;\n  font-size: .95rem;\n  font-weight: 700;\n  color: var(--primary);\n  letter-spacing: .08em;\n  flex: 1;\n}\n.copy-btn { background: none; border: none; font-size: 1rem; cursor: pointer; padding: 2px; }\n.copy-btn:hover { opacity: .7; }\n\n.licence-meta {}\n.meta-row {\n  display: flex;\n  justify-content: space-between;\n  padding: 8px 0;\n  font-size: .875rem;\n  border-bottom: 1px solid var(--border);\n}\n.meta-row:last-child { border: none; }\n.meta-row span { color: var(--text-muted); }\n\n/* ── Pending orders ── */\n.order-row {\n  background: var(--white);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-sm);\n  padding: 20px 24px;\n  margin-bottom: 12px;\n}\n.order-info { font-size: .95rem; margin-bottom: 6px; }\n.order-meta { font-size: .85rem; color: var(--text-muted); margin-bottom: 12px; }\n.order-cheque {\n  background: #fffbeb;\n  border: 1px solid #fde68a;\n  border-radius: 6px;\n  padding: 12px 16px;\n  font-size: .875rem;\n  line-height: 1.7;\n  color: #78350f;\n}\n.order-cheque code { background: #fef3c7; padding: 2px 6px; border-radius: 4px; font-size: .85rem; }\n\n/* ── Table ── */\n.orders-table-wrap { overflow-x: auto; }\n.orders-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: .875rem;\n}\n.orders-table th {\n  text-align: left;\n  padding: 10px 14px;\n  background: var(--surface);\n  border-bottom: 2px solid var(--border);\n  font-size: .78rem;\n  text-transform: uppercase;\n  letter-spacing: .05em;\n  color: var(--text-muted);\n}\n.orders-table td {\n  padding: 12px 14px;\n  border-bottom: 1px solid var(--border);\n  color: var(--text);\n}\n.orders-table tr:last-child td { border-bottom: none; }\n.orders-table tr:hover td { background: var(--surface); }\n\n/* ── Download ── */\n.download-card {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 24px;\n  background: var(--white);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  padding: 24px 28px;\n}\n.download-info h3 { font-size: 1rem; font-weight: 700; margin-bottom: 4px; }\n.download-info p { font-size: .875rem; color: var(--text-muted); }\n\n@media (max-width: 768px) {\n  .licence-grid { grid-template-columns: 1fr; }\n  .download-card { flex-direction: column; align-items: flex-start; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
